module.exports = __webpack_public_path__ + "static/trade-6-92659b80e02d646ac4ece126ed9cfed6.svg";